import { createSlice } from "@reduxjs/toolkit";
import type { AssetFromMap } from "../models/AssetFromMap";

const MapInitialState: {
	loadingMap: boolean;
	clicked: boolean;
	anchorPoint: any;
	showContextMenu: boolean;
	menuContextAssetId: number | undefined;
	currAssetId: string | number | null;
	showModalHiddenChildrens: boolean;
	showHiddenChildrenButton: boolean;
	listHiddenChildrenIds: any;
	assetChildrensFromApi: AssetFromMap[];
	hiddenChildrenList: AssetFromMap[];

	assetNameFromApi: string;
	RMWorkOrdersFromApi: string;
	PMWorkOrdersFromApi: string;
	PMWorkOrdersClosedFromApi: string;
	RMWorkOrdersClosedFromApi: string;

	navigationHistory: (string | number)[];
	navigationIndex: number;
	canGoBack: boolean;
	canGoForward: boolean;
} = {
	loadingMap: false,
	clicked: false,
	anchorPoint: {
		x: 0,
		y: 0,
	},
	showContextMenu: false,
	menuContextAssetId: undefined,
	currAssetId: null,
	showModalHiddenChildrens: false,
	showHiddenChildrenButton: false,
	listHiddenChildrenIds: [],
	assetChildrensFromApi: [],
	hiddenChildrenList: [],

	assetNameFromApi: "",
	RMWorkOrdersFromApi: "",
	PMWorkOrdersFromApi: "",
	PMWorkOrdersClosedFromApi: "",
	RMWorkOrdersClosedFromApi: "",

	navigationHistory: [],
	navigationIndex: -1,
	canGoBack: false,
	canGoForward: false,
};

export const MapReducer = createSlice({
	name: "__",
	initialState: MapInitialState,
	reducers: {
		setLoadingMap(state, { payload }) {
			state.loadingMap = payload;
		},
		setClicked(state, { payload }) {
			state.clicked = payload;
		},
		setAnchorPointX(state, { payload }) {
			state.anchorPoint.x = payload;
		},
		setAnchorPointY(state, { payload }) {
			state.anchorPoint.y = payload;
		},
		setShowContextMenu(state, { payload }) {
			state.showContextMenu = payload;
		},
		setMenuContextAssetId(state, { payload }) {
			state.menuContextAssetId = payload;
		},
		setCurrAssetId(state, { payload }) {
			state.currAssetId = payload;
		},
		setShowHiddenChildrenButton(state, { payload }) {
			state.showHiddenChildrenButton = payload;
		},
		setShowModalHiddenChildrens(state, { payload }) {
			state.showModalHiddenChildrens = payload;
		},
		setListHiddenChildrenIds(state, { payload }) {
			state.listHiddenChildrenIds = payload;
		},
		setAssetChildrensFromApi(state, { payload }) {
			state.assetChildrensFromApi = payload;
		},
		setHiddenChildrenList(state, { payload }) {
			state.hiddenChildrenList = payload;
		},
		// ===================================================
		// DATA FROM API
		setAssetNameFromApi(state, { payload }) {
			state.assetNameFromApi = payload;
		},
		setRMWorkOrdersFromApi(state, { payload }) {
			state.RMWorkOrdersFromApi = payload;
		},
		setPMWorkOrdersFromApi(state, { payload }) {
			state.PMWorkOrdersFromApi = payload;
		},
		setPMWorkOrdersClosedFromApi(state, { payload }) {
			state.PMWorkOrdersClosedFromApi = payload;
		},
		setRMWorkOrdersClosedFromApi(state, { payload }) {
			state.RMWorkOrdersClosedFromApi = payload;
		},
		pushToHistory(state, { payload }) {
			const assetId = payload;
			if (state.navigationHistory[state.navigationIndex] === assetId) {
				return;
			}
			state.navigationHistory = state.navigationHistory.slice(
				0,
				state.navigationIndex + 1,
			);
			state.navigationHistory.push(assetId);
			state.navigationIndex = state.navigationHistory.length - 1;
			state.canGoBack = state.navigationIndex > 0;
			state.canGoForward = false;
		},
		navigateBack(state) {
			if (state.navigationIndex > 0) {
				state.navigationIndex -= 1;
				state.currAssetId = state.navigationHistory[state.navigationIndex];
				state.canGoBack = state.navigationIndex > 0;
				state.canGoForward = true;
			}
		},
		navigateForward(state) {
			if (state.navigationIndex < state.navigationHistory.length - 1) {
				state.navigationIndex += 1;
				state.currAssetId = state.navigationHistory[state.navigationIndex];
				state.canGoBack = true;
				state.canGoForward =
					state.navigationIndex < state.navigationHistory.length - 1;
			}
		},
	},
});
